import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { PrintHelpers } from '../../../components'
import {Label} from "../../../components/prints/utils";
const borderStyle = { border: '1px solid #424242', paddingTop: '10px' }
export const WatchReleaseOfLiabilityForm = ({
  ticket
}) => {
  const { organization, device, customer} = ticket

  return (
    <ReactBootstrap.Row style={{fontSize:"20px",lineHeight:"1.5rem"}} className="p-2 print_zone">
      <ReactBootstrap.Row className="pl-5 pr-5">
        <ReactBootstrap.Col style={borderStyle} xs={12}>
          <PrintHelpers.Header
            legend="Watch Release Of Liability"
            organization={organization}
          />
        </ReactBootstrap.Col>
<ReactBootstrap.Row className="ms-0 me-5" style={borderStyle}>
    <ReactBootstrap.Col className={"mb-3"} xs={12}>
         <PrintHelpers.Strong value={"Release for devices purchased abroad and brought in for service"}/>
    </ReactBootstrap.Col>
         <ReactBootstrap.Col className="printsection" xs={12}>
            <p style={{ lineHeight: '25px' }}>
             I
              <strong className="ps-2 pe-2">
                {customer.first_name} {customer.last_name}
              </strong> ("Customer")
              understand that the
Apple Watch Model number {device.model_number}, and serial number
<PrintHelpers.Strong value={device.serial_number}/>, was purchased in a foreign country;
which may result in functionality and technical specifications that are
different from a replacement product that complies with the specifications
and requirements for the country in which the device is presented for service,
in this case, <PrintHelpers.Strong value={organization.country} />(country of service). Upon accepting
the replacement of my product, I accept and release Apple, its subsidiaries
and the Apple Authorised Service Provider from any liability for any device
incompatibility and functionality limitations in the country of origin, including,
                but not limited to, use and/or availability of certain features.</p>

          </ReactBootstrap.Col>

 <ReactBootstrap.Col className={"mb-3"} style={{marginTop:"30px"}} xs={12}>
         <PrintHelpers.Label value={"Release for devices purchased abroad and brought in for service"}/>
    </ReactBootstrap.Col>
<ReactBootstrap.Col className="printsection" xs={12}>
            <p style={{ lineHeight: '25px' }}>
             I
              <strong className="ps-2 pe-2">
                {customer.first_name} {customer.last_name}
              </strong> ("Customer")
              understand that the
Apple Watch Model number {device.model_number}, and serial number
<PrintHelpers.Strong value={device.serial_number}/>, was purchased in a foreign country;
which may result in functionality and technical specifications that are
different from a replacement product that complies with the specifications
and requirements for the country in which the device is presented for service,
in this case, <PrintHelpers.Strong value={organization.country}/>(country of service). Upon accepting
the replacement of my product, I accept and release Apple, its subsidiaries
and the Apple Authorised Service Provider from any liability for any device
incompatibility and functionality limitations in the country of origin, including,
                but not limited to, use and/or availability of certain features.</p>

          </ReactBootstrap.Col>






         <ReactBootstrap.Col style={{marginTop:"60px",marginBottom:"60px"}} className={"text-end"} xs={12}>
          <PrintHelpers.Strong value={organization.name}/>
        </ReactBootstrap.Col>


</ReactBootstrap.Row>

           <ReactBootstrap.Col style={borderStyle}  xs={12}>
                   <PrintHelpers.TimeStamp
            label="Data and Time"
            value={ticket.watch_release_of_liability_signature_timestamp}
          />
                <p>
        <Label className="clearfix" value={'Place'} />
        {ticket.organization.city}
      </p>

            </ReactBootstrap.Col>


        <ReactBootstrap.Col style={borderStyle} className="text-left" xs={6}>
          <PrintHelpers.Signature signature={ticket.created_by_signature} />
          <PrintHelpers.InlineText value={ticket.created_by} />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} className="text-end" xs={6}>


 <PrintHelpers.InlineText value={'Customer Signature'} />
          <PrintHelpers.Signature signature={ticket.customer_watch_release_of_liability_signature_s3_path} />

              <PrintHelpers.InlineText value={`${customer.first_name} ${customer.last_name}`} />

        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </ReactBootstrap.Row>
  )
}
